export * from './InspiringSearchRecommendations.DynamicWrapper';
